
const filterSearchConditions = (conditions) => {
    if (!conditions) {
        return {};
    }

    if (conditions.hasUnreadMessages === 'Either') {
        delete conditions.hasUnreadMessages;
    }
    if (conditions.balance === 'Any') {
        delete conditions.balance;
    }
    if (conditions.hasLocation === 'Either') {
        delete conditions.hasLocation;
    }
    if (conditions.type === 'Either') {
        delete conditions.type;
    }
    if (conditions.roundId === 'no-round') {
        delete conditions.roundId;
    }

    Object.keys(conditions).forEach(key => {
        if (conditions[key] === null || conditions[key] === undefined || conditions[key] === '') {
            delete conditions[key];
        }
    });

    return conditions;
}

export default filterSearchConditions;